import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl } from '@angular/forms';
import { of, Observable } from 'rxjs';
import { Userlist } from '../_services/_mocks/mockUserlist';
import { User } from '../_models/user';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../_services/app.service';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-mail-sender',
  templateUrl: './mail-sender.component.html',
  styleUrls: ['./mail-sender.component.scss']
})
export class MailSenderComponent implements OnInit {
  currentUser: User;
  userRole: number;
  searching: boolean = false;

  @Input() anyEmail: boolean = true;
  @Input() loading: boolean = false;
  @Output() onSend = new EventEmitter<any>();

  items = [];

  @ViewChild('container', { static: true }) container: ElementRef;
  @ViewChild('containerDriver', { static: true }) containerDriver: ElementRef;
  splitPattern = /[,;\n\r]+/;
  public validators = [this.must_be_email];
  public errorMessages = {
    must_be_email: ''
  };
  private must_be_email(control: FormControl) {
    var EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/i;
    if (control.value.length != '' && !EMAIL_REGEXP.test(control.value)) {
      return { must_be_email: true };
    }
    return null;
  }

  constructor(
    private http: HttpClient,
    private modalService: NgbModal,
    private appService: AppService,
    private translateService: TranslateService) { }

  ngOnInit(): void {
    this.translateService.get("mail_sender.validation").subscribe((result: string) => this.errorMessages.must_be_email = result);
    this.retrieveUserData();
  }

  retrieveUserData() {
    this.currentUser = JSON.parse(localStorage.getItem("user"));
    if(this.currentUser != undefined){
      this.userRole = this.currentUser.locationRoles[this.currentUser.selectedLocationIndex].RoleId;
    }
  }

  public requestAutocompleteItems = (text: string): Observable<any> => {
    this.searching = true;
    return this.http.get(`${environment.apiUrl}/api/mail/searchuser/${text}`).pipe(
      map(data => {
        this.searching = false;
        return data;
      }),
      catchError(err => {
        this.searching = false;
        // Puedes mostrar un mensaje de error aquí si lo deseas
        return of(""); // Devuelve un array vacío en caso de error
      })
    );
  };

  send() {
    this.onSend.emit(this.items);
  }

  open(_isDriverView?) {
    if(_isDriverView){
      this.items = [];
      this.modalService.open(this.containerDriver, { ariaLabelledBy: 'modal-basic-title' });
    }
    else{
      this.items = [];
      this.modalService.open(this.container, { ariaLabelledBy: 'modal-basic-title' });
    }
  }

  close() {
    this.modalService.dismissAll('Closed');
  }
}
